import { NodeTypeKeys } from '../../utils/NodeTypeKeys';
import { Position } from '../../types';
import { Leaf } from '../Leaf';
import { Leaf as ILeaf } from '../../types';

const branchNameAllowedNodeTypes = [NodeTypeKeys.endOfFlowNodeType];

const restrictAllowedTypes = (types: string[], restrictTo: string, next: ILeaf) => {
  const allowed = types.find(s => s === restrictTo) ? types : [...types, restrictTo];

  if (next) {
    allowed.filter(s => s !== next.type);
  }

  return allowed;
};

export class BranchNameNode extends Leaf {
  public constructor(
    id: string,
    restrictToType: string,
    allowedNodeTypes: string[] = branchNameAllowedNodeTypes,
    position: Position = undefined,
    next: ILeaf = undefined,
    isHidden: boolean = undefined,
  ) {
    super(id, NodeTypeKeys.branchNameNodeType, restrictAllowedTypes(allowedNodeTypes, restrictToType, next), {
      position,
      isHidden,
      next,
    });

    this.order = 1;
  }

  public order: number;
}
